import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert } from "../alert/alertSlice";

// Get all chat rooms for a user
export const get_user_chatrooms_thunk = createAsyncThunk(
  "user/chatroom/getUserRooms",
  async (userId, thunkAPI) => {
    try {
      const response = await getDataAPI(`user/chatroom`);
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to fetch chat rooms")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to fetch chat rooms"
      );
    }
  }
);

// Get chat room by ID
export const get_chatroom_by_id_thunk = createAsyncThunk(
  "user/chatroom/getById",
  async ({ roomId, userId }, thunkAPI) => {
    try {
      const response = await getDataAPI(`user/chatroom/${roomId}`);
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to fetch chat room")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to fetch chat room"
      );
    }
  }
);

// Get unread count for a user
export const get_unread_count_thunk = createAsyncThunk(
  "user/chatroom/unreadCount",
  async (userId, thunkAPI) => {
    try {
      const response = await getDataAPI(`user/chatroom/unread`);
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to fetch unread counts")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unread counts"
      );
    }
  }
);

// Mark chat room messages as read
export const mark_chatroom_messages_as_read_thunk = createAsyncThunk(
  "user/chatroom/markAsRead",
  async ({ roomId, userId }, thunkAPI) => {
    try {
      const response = await putDataAPI(`user/chatroom/${roomId}/read`, { userId });
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to mark messages as read")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to mark messages as read"
      );
    }
  }
);

// Update chat room status
export const update_chatroom_status_thunk = createAsyncThunk(
  "user/chatroom/updateStatus",
  async ({ roomId, status }, thunkAPI) => {
    try {
      const response = await putDataAPI(`user/chatroom/${roomId}/status`, { status });
      thunkAPI.dispatch(
        setErrorAlert({ 
          msg: "Chat status updated successfully", 
          type: "success"
        })
      );
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to update chat status")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to update chat status"
      );
    }
  }
); 